import { FC } from 'react';
import { useContextSelector as useCS } from 'use-context-selector';
import { Modal } from '@mui/material';
import { CloseIcon, DeleteAccountModalIcon } from 'assets';
import { TUpdate } from 'domain/types';
import { Button } from 'view/components';
import * as CS from 'view/modals/styled';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { useDeleteJobPostById } from 'view/pages/candidates/hooks/useDeleteJobPostById';

const DeleteJobPostModal: FC<{ hideCloseButton?: boolean; successFunction: any }> = ({
  hideCloseButton = false,
  successFunction,
}) => {
  const isOpenDeleteJobPostModal: boolean = useCS(
    GlobalConfigContext,
    globalConfigSelectors.isOpenDeleteJobPostModal
  );

  const jobPostIdToDelete: number | null = useCS(
    GlobalConfigContext,
    globalConfigSelectors.jobPostIdToDelete
  );

  const update: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );

  const { isLoading, deleteJobPostById } = useDeleteJobPostById();

  const onClose = () => {
    if (update) update({ isOpenDeleteJobPostModal: false, jobPostIdToDelete: null });
  };

  const onDeleteClick = () => {
    deleteJobPostById(jobPostIdToDelete, successFunction);
  };

  return (
    <Modal
      open={isOpenDeleteJobPostModal}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <CS.ModalMainWrapper>
        {!hideCloseButton ? (
          <CS.CloseIconBox onClick={onClose}>
            <CloseIcon />
          </CS.CloseIconBox>
        ) : null}
        <CS.ModalMainBox>
          <CS.ModalMainImage>
            <DeleteAccountModalIcon />
          </CS.ModalMainImage>
          <CS.ModalMainHeader>
            <CS.ModalMainHeaderTitle>Delete Job Post</CS.ModalMainHeaderTitle>
            <CS.ModalMainHeaderSubTitle>
              {
                'After you delete this job, you will no longer have access to it. \n Are you sure you want to delete this job?'
              }
            </CS.ModalMainHeaderSubTitle>
          </CS.ModalMainHeader>
        </CS.ModalMainBox>
        <CS.ModalMainFooter>
          <Button
            className="red-button"
            variant="outlined"
            text="Delete"
            onClick={onDeleteClick}
            disabled={isLoading}
            style={{ width: '100%', minHeight: '50px' }}
          />
          <Button variant="contained" text="Cancel" onClick={onClose} />
        </CS.ModalMainFooter>
      </CS.ModalMainWrapper>
    </Modal>
  );
};

export default DeleteJobPostModal;
